let initialized = false
if (typeof window !== 'undefined') {
    !!(window as any).google
}

export default function gmapInit(key: string) {
    return new Promise((r, e) => {
        // If Google Maps already is initialized
        // the `initPromise` should get resolved
        // eventually.
        if (initialized) {
            if (typeof window !== 'undefined') {
                r((window as any).google)
            }
        }

        initialized = true
        // The callback function is called by
        // the Google Maps script if it is
        // successfully loaded.
        if (typeof window !== 'undefined') {
            ;(window as any)['gmapsCallback'] = () => r((window as any).google)
        }

        // We inject a new script tag into
        // the `<head>` of our HTML to load
        // the Google Maps script.
        const script = document.createElement('script')
        script.async = true
        script.defer = true
        script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=gmapsCallback&libraries=places`
        script.onerror = e
        document.querySelector('head').appendChild(script)
    })
}
